import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/futureup.webp';
import screenshot_target from '../../../images/letterfunnel/ankievanwersch.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Ankie van Wersch"
      firstname="Ankie"
      companyname="Future Up"
      competition="Sustainalize en B Lab Benelux"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/ankievanwersch.js